import Backbone from 'backbone';
import Localizer from 'localizer';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import templateHtml from 'templates/main/Modal/ModalWarningView.html';

var MessageView = Backbone.View.extend({
    template: _.template(templateHtml),

    initialize: function(args) {
        this.message = args.message;
        this.errorMessage = args.errorMessage;
    },

    render: function() {
        this.$el.html(
            this.template({
                message: this.message,
                errorMessage: this.errorMessage
            })
        );
    }
});

var ModalWarningView = ModalPopupView.extend({
    initialize: function(args) {
        if (!args.message) {
            throw 'Message required for ModalWarningView';
        }

        this.messageView = new MessageView({
            message: args.message,
            errorMessage: args.errorMessage || ''
        });

        args.view = this.messageView;

        ModalPopupView.prototype.initialize.call(this, args);
    },

    render: function() {
        ModalPopupView.prototype.render.call(this);
        this.$('.js-saveBtn').addClass('btn-danger');
    },

    errorOccurred: function() {
        if (this.messageView.errorMessage) {
            this.messageView.$('.alert-error').show();
        }
    }
});

ModalWarningView.Events = ModalPopupView.Events;
export default ModalWarningView;
